import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Marketing } from '../../../marketing/marketing';
import { genPaymentBillingPath } from '../../../utils/formatter/path.formatter';
import { getMixpanelPlanName } from '../utils/get-mixpanel-plan-name-utils';
import { PlanT } from '../payment.types';
import { usePaymentFilters } from '../hooks/payment-filters.hook';
import { PlanExtraFeature } from '../../../__generated/treasury/types';

export const usePlanSelection = () => {
  const { push } = useHistory();
  const { search } = useLocation();
  const { t } = useTranslation();
  const { productAbbreviation, gameName } = usePaymentFilters();

  const handlePlanClick = (plan: PlanT) => {
    if (!productAbbreviation) return;
    const mixpanelName = getMixpanelPlanName(plan, productAbbreviation, gameName, t);
    if (mixpanelName) {
      Marketing.planSelected(mixpanelName);
    }

    const isTftFreeEggPlan = Boolean(plan.planFeatures?.find((it) => it === PlanExtraFeature.EGG_SKIN));
    push(genPaymentBillingPath(plan.id, search, isTftFreeEggPlan));
  };

  return {
    handlePlanClick,
  };
};
